(() => {
  const TEXT_FIXES = [
    [/Tu carrito esta vacío/g, 'Tu carrito está vacío'],
    [/¿Tienes una cuenta\?/g, '¿Tenés una cuenta?'],
    [/Inicia sesión/g, 'Iniciá sesión'],
    [/Precio\s*\$\{\{amount\}\}/g, 'Precio'],
    [/\$\{\{amount\}\}/g, ''],
    [/\{\{amount\}\}/g, '']
  ];

  const norm = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function fixTextNodes(root = document.body) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return TEXT_FIXES.some(([regex]) => regex.test(node.nodeValue || ''))
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      let value = node.nodeValue || '';
      TEXT_FIXES.forEach(([regex, replacement]) => {
        value = value.replace(regex, replacement);
      });
      node.nodeValue = value;
    });
  }

  function cleanProductActions(root = document) {
    const scope = '.product-card, product-card, .product-grid__item, .product-grid-container';
    root.querySelectorAll(`${scope} a, ${scope} button, ${scope} summary`).forEach((element) => {
      const text = norm(element.textContent);
      const aria = norm(element.getAttribute('aria-label'));
      const className = `${element.className || ''}`.toLowerCase();
      const dataset = Object.values(element.dataset || {}).join(' ').toLowerCase();

      const isCompare = text === 'comparar' || aria === 'comparar' || className.includes('compare') || dataset.includes('compare');
      const isChoose = text === 'elegir' || text === 'elegir opciones' || aria === 'elegir opciones' || className.includes('quick-add__button--choose') || dataset.includes('choose');

      if (isCompare || isChoose) {
        element.remove();
      }
    });
  }

  function cleanup() {
    fixTextNodes();
    cleanProductActions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup, { once: true });
  } else {
    cleanup();
  }

  let raf = null;
  new MutationObserver(() => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(cleanup);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
